import React from "react";
// import * as R from "ramda";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const TestWrapper = styled.div`
  p.khorInt_Titulo1 {
    font-weight: bold;
    border-bottom: 1px solid #00000024;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
  }
`;

// Only for "Evaluación Psicométrica Atento"
const resultNames = [
  "Operaciones",
  "Alta Confidencialidad",
  "Armstrong",
  "Presenciales Telefónica"
];

export default function ExternalTest({ url, files = [] }) {
  const { t } = useTranslation(["opportunity"]);

  try {
    return (
      <TestWrapper>
        {files.length > 0 ? (
          files.map((url, i) => (
            <div>
              <a
                href={url.replace(",pdf_", "_")}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`${t(
                  "opportunity:process.candidateDetails.testVisualizeResult"
                )} - ${resultNames[i]}`}
              </a>
            </div>
          ))
        ) : (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {t("opportunity:process.candidateDetails.testVisualizeResult")}
          </a>
        )}
      </TestWrapper>
    );
  } catch (e) {
    console.error(e);
    return (
      <TestWrapper>
        <p>{t("opportunity:process.candidateDetails.testVisualizeError")}</p>
      </TestWrapper>
    );
  }
}
